import isEqual from 'lodash.isequal'
import { createRule } from '@/utils/factory/contract/rule'
import { getDateFromObjectId } from '@/utils/helpers/contract'

class Contract {
  constructor(contract = {}) {
    this.id = contract.id
    this.code = contract.companyCode || contract.code || ''
    this.companyName = contract.companyName || ''
    this.clientId = contract.clientId || ''
    this.email = contract.email
    this.contractDate = getDateFromObjectId(contract.id)
    this.startDate = contract.startDate
    this.endDate = contract.endDate
    this.contractType = contract.contractType || 'month'
    this.contractValue = contract.contractValue || 0
    this.documentLink = contract.documentLink || ''
    this.contractRules =
      (contract.contractRules && contract.contractRules.map(createRule)) || []
  }

  setCompanyName(companyName) {
    this.companyName = companyName
  }

  mergeContracts(contract) {
    if (contract.code) {
      this.code = contract.code
      this.companyName = contract.companyName || ''
    }
    this.startDate = contract.startDate
    this.endDate = contract.endDate
    this.contractType = contract.contractType
    this.contractValue = contract.contractValue
    this.documentLink = contract.documentLink
    this.contractRules = contract.contractRules.map((rule) =>
      createRule(rule.deepClone())
    )
  }

  isEqual(contract) {
    return isEqual(this, contract)
  }

  addRule(rule) {
    this.contractRules.push(rule)
  }

  deepClone() {
    return new Contract({
      ...this,
      contractRules: this.contractRules.map((rule) => rule.deepClone())
    })
  }

  toJSON() {
    return {
      companyCode: this.code,
      email: this.email,
      startDate: this.startDate,
      clientId: this.clientId,
      endDate: this.endDate,
      contractType: this.contractType,
      contractValue: this.contractValue,
      documentLink: this.documentLink,
      contractRules: this.contractRules.map((rule) => rule.toJSON())
    }
  }
}

export function createContract(contract) {
  return new Contract(contract)
}
